import { makeStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Panel from '~components/content-header/panel';
import TopBar from '~components/content-header/top-bar';
import { useHeaderSticky } from './use-header-sticky';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'sticky',
    top: 0,
    zIndex: '999',
    width: '100%',
    transition: '0.5s box-shadow',
  },

  sticky: {
    backgroundColor: theme.colors.white,
    boxShadow: theme.shadow.main,
  },
}));

/**
 * Simple guideline
 * https://github.com/Project-G66-Org/projectg-fe-pms/pull/67
 */
function ContentHeader(props) {
  const classes = useStyles();
  useTranslation(['booking', 'global-search']);
  const sticky = useHeaderSticky();

  return (
    <div
      className={classNames(classes.root, { [classes.sticky]: sticky })}
      id="for-release-hint-content-header"
    >
      <TopBar isSticky={sticky} />
      <Panel {...props} />
    </div>
  );
}

ContentHeader.propTypes = {
  showAcademicYearTab: PropTypes.bool,
};

export default ContentHeader;
